@if (useCustomColors()) {
  <span
    class="cm-chip-custom"
    [style.background-color]="backgroundColor()"
    [style.color]="textColor()"
  >
    <ng-container *ngTemplateOutlet="chipContent" />
  </span>
} @else {
  <neo-chip [color]="neoColor()" [size]="size()">
    <ng-container *ngTemplateOutlet="chipContent" />
  </neo-chip>
}

<ng-template #chipContent>
  <ng-content />
</ng-template>